<template>
    <div >
        <!-- <div class="row mb-2" >
            <div class="col-4">
                {{key}}
            </div>
            <div class="col-1">
                :
            </div>
            <div class="col-7">
                {{datas[0][key]}}
            </div>
        </div> -->
        <h3>Log Detail</h3>
        <h5>ID : {{id}}</h5>
        <p style="text-align:left" v-if="reason">Reason : {{reason}}</p>
        <p style="text-align:center" v-else>Status : Success</p>
        <div class="table-div" style="height:65vh;width:100wh">
            <table class="table">
                <tbody v-for="(key, index) in keys"> 
                    <tr :class="{'backgroundRed' : index == errorIndex}">
                        <td>{{key.split('_').join(' ')}}</td>
                        <td>:</td>
                        <td>{{datas[0][key]}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
        
    </div>
</template>

<script>
export default {
    props : ['datas', 'id' , 'reason'],
    data(){
        return {
            keys : [],
            modifiedKeys : [],
            errorIndex : null
        }
    },
    mounted(){
        this.keys = Object.keys(this.datas[0]);
        for(var i = 0 ; i < this.keys.length ; i++){
            console.log(this.reason.includes(this.datas[0][this.keys[i]]))
            if(this.reason != '' && this.datas[0][this.keys[i]] != '' && this.reason.includes(this.datas[0][this.keys[i]])){
                console.log('a');
                this.errorIndex = i;
                break;
            }
                
        }
    }
}
</script>

<style>
    .backgroundRed{
        color: #ff3333;
    }
    .table-div{
        display: block;
        overflow: scroll;
        overflow-y : scroll;
    }
</style>
